import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Api } from '../../../../services/api/api.service';
import { LeaveCalendar } from '../../../../models/api/view/claim/summary/leavecalendar';
import { ViewService } from '../../../../services/view/view.service';

@Injectable({ providedIn: 'root' })
export class LeaveCalendarResolver implements Resolve<LeaveCalendar[]> {
  private api = inject(Api);
  private view = inject(ViewService);


  async resolve(route: ActivatedRouteSnapshot): Promise<LeaveCalendar[]> {
    // Get recordSource and recordId from parent route parameters
    const recordSource = route.parent?.params['recordSource'];
    const recordId = route.parent?.params['recordId'];

    if (!recordSource || !recordId) {
      return [];
    }

    // Ensure current claim is loaded
    const currentClaim = this.view.currentClaim();
    if (
      !currentClaim ||
      currentClaim.recordSource !== recordSource ||
      currentClaim.recordId !== recordId ||
      currentClaim.ssnMask === undefined
    ) {
      const claimHeader = await this.api.claimHeader.get({
        recordSource,
        recordId: recordId,
      });
      this.view.setCurrentClaim(claimHeader);
    } else {
      this.view.applyClaimSsnMasking(currentClaim);
    }

    // Fetch leave calendar data
    const absences = await this.api.claimSummary.getLeaveCalendar(
      recordSource,
      recordId,
    );

    // Get the current claim for employee name fallback
    const claim = this.view.currentClaim();
    const fullName = claim
      ? `${claim.claimantFirstName || ''} ${
          claim.claimantLastName || ''
        }`.trim()
      : '';

    // Ensure employeeName is always a string (use claim full name if empty)
    return absences.map((absence) => ({
      ...absence,
      employeeName: absence.employeeName || fullName || '',
    }));
  }
}
